module.exports = __webpack_public_path__ + "static/media/lancome-la-nuit-tresor-a-la-folie-big.a7662920.png";